import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getShiftByNip, getTodayShift } from './firebase';
import { STATUS_FETCHING, STATUS_ERROR, STATUS_READY, STATUS_IDLE } from './constants';

export const fetchShift = createAsyncThunk(
  'fetchShift',
  async ({ nip, firstDay, lastDay }) => await getShiftByNip(nip, firstDay, lastDay)
);

export const fetchTodayShift = createAsyncThunk(
  'fetchTodayShift',
  async (date) => await getTodayShift(date)
);

const shiftSlice = createSlice({
  name: 'shift',
  initialState: {
    status: STATUS_IDLE,
    data: null,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchShift.pending, (state, action) => {
        state[action.meta.arg.nip] = {};
        state[action.meta.arg.nip].status = STATUS_FETCHING;
      })
      .addCase(fetchShift.fulfilled, (state, action) => {
        state[action.meta.arg.nip].status = STATUS_READY;
        state[action.meta.arg.nip].data = action.payload?.sort(
          (a, b) => a.shiftStartTime - b.shiftStartTime
        );
      })
      .addCase(fetchShift.rejected, (state, action) => {
        state[action.meta.arg.nip].status = STATUS_ERROR;
        state[action.meta.arg.nip].error = action.error.message;
      })
      .addCase(fetchTodayShift.pending, (state, action) => {
        state.status = STATUS_FETCHING;
      })
      .addCase(fetchTodayShift.fulfilled, (state, action) => {
        state.status = STATUS_READY;
        state.data = action.payload;
      })
      .addCase(fetchTodayShift.rejected, (state, action) => {
        state.status = STATUS_ERROR;
        state.error = action.error.message;
      });
  },
});

export default shiftSlice.reducer;
